import { render } from "./lockscreen.vue?vue&type=template&id=635bef62&scoped=true"
import script from "./lockscreen.vue?vue&type=script&lang=js"
export * from "./lockscreen.vue?vue&type=script&lang=js"

import "../styles/lockscreen.css?vue&type=style&index=0&id=635bef62&scoped=true&lang=css"

import exportComponent from "C:\\Users\\eoladipo\\Documents\\Windows 10 Mock\\Windows10-mock\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635bef62"]])

export default __exports__